<template lang="pug"></template>

<script>
export default {
    name: 'BotaoMonitoramentoAgricola',
    componentOptions: {
        title: 'MonitoramentoAgricola',
        actions: [
            [
                {
                    name: 'Monitoramento Agrícola',
                    iconClass: 'lyra-icon lyra-agricola',
                    showView: false,
                    action: 'abrirMonitoramentoAgricola',
                    route: 'MonitoramentoAgricola'
                }
            ]
        ]
    },

    methods: {
        abrirMonitoramentoAgricola() {
            if (this.$route.name !== 'MonitoramentoAgricola') {
                this.$router.push({
                    name: 'MonitoramentoAgricola',
                    params: { periodoAlerta: null }
                });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
